import { render, staticRenderFns } from "./InternationalPhoneNumberInput.vue?vue&type=template&id=5f754023"
import script from "./InternationalPhoneNumberInput.vue?vue&type=script&lang=ts"
export * from "./InternationalPhoneNumberInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports